import {FILTER_DATA, NOT_DIRECT_FILTER_DATA} from '../Types/types'

export function storeFilter(data: any) {
  return {
    type: FILTER_DATA,
    payload: data
  }
}

export function storeNotDirectFilter(data: any) {
  return {
    type: NOT_DIRECT_FILTER_DATA,
    payload: data
  }
}
